 const contactData = {
  address: "Plot No: 22 & 23, Saket, Vorla Enclave, ECIL, Secunderabad, Hyderabad, Telangana- 500062.",
  mobile: "+91 966 966 8687",
  email: "care@wihan.in",
};

export default contactData;
